<template>
    <div :class="classMainBlock">
        <label :for="id">
            {{ title }}
        </label>
        <div
            v-if="$slots['info']"
            class="additional-info"
        >
            <slot name="info" />
        </div>
        <div class="form-check custom-check">
            <div class="button">
                <input
                    :id="id"
                    v-model="itemModel"
                    type="checkbox"
                    :disabled="disabled"
                    @change="onChange"
                />
                <div class="knobs">
                    <span></span>
                </div>
                <div class="layer"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    props: {
        title: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        id: { type: String, default: '' },
        classMainBlock: { type: String, default: '' },
        selected: { type: Boolean, default: false },
    },
    data: function () {
        return {
            itemModel: this.selected,
        };
    },
    methods: {
        onChange() {
            this.emitChange();
        },
        getValue() {
            return this.itemModel;
        },
        emitChange() {
            this.$emit('change', this.getValue());
        },
        clear() {
            this.itemModel = null;
        },
    },
};
</script>
